import React, { useEffect, useRef, useState } from 'react';
import { loadScript } from '@paypal/paypal-js';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';

import { alertActions } from '../../../../store/actions';
import { getVenmoPaymentIntent } from '../../../../helpers/PaymentHandlers';

export default function VenmoPay({ state }) {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [eligible, setEligible] = useState(false);
	const venmoButtonRef = useRef(null);
	const redirectUrlRef = useRef(null);

	useEffect(() => {
		if (!state.paypalPublicKey) return;
		let isMounted = true;

		loadScript({
			clientId: state.paypalPublicKey,
			components: 'buttons,funding-eligibility',
			'enable-funding': 'venmo',
			'buyer-country': 'US',
		})
			.then((paypal) => {
				if (!isMounted || !paypal || typeof paypal.Buttons !== 'function') {
					setLoading(false);
					return;
				}

				const venmoButton = paypal.Buttons({
					fundingSource: paypal.FUNDING.VENMO,
					style: {
						layout: 'vertical',
						shape: 'rect',
						height: 44,
						label: 'donate',
					},
					createOrder: async () => {
						const result = await getVenmoPaymentIntent();
						redirectUrlRef.current = result.redirect_url;
						return result.venmo_order_id;
					},
					onApprove: (data) => {
						const url = new URL(redirectUrlRef.current);
						url.searchParams.append('token', data.orderID);
						url.searchParams.append('PayerID', data.payerID);
						window.location.href = url.toString();
					},
					onCancel: () => {},
					onError: (err) => {
						console.error('Venmo payment error:', err);
						dispatch(alertActions.error('Something went wrong with the Venmo payment'));
					},
				});

				// The container div is rendered unconditionally below (see JSX), so it's already
				// in the DOM by the time this promise resolves — render() no longer races React's
				// own paint.
				if (venmoButton.isEligible()) {
					venmoButton.render('#venmo-button-container');
					venmoButtonRef.current = venmoButton;
					setEligible(true);
				}
				setLoading(false);
			})
			.catch((err) => {
				console.error('Failed to load PayPal JS SDK for Venmo:', err);
				setLoading(false);
			});

		return () => {
			isMounted = false;
			if (venmoButtonRef.current) {
				venmoButtonRef.current.close();
				venmoButtonRef.current = null;
			}
		};
	}, [state.paypalPublicKey]);

	return (
		<>
			{loading && <Typography>Please wait, loading Venmo…</Typography>}
			{!loading && !eligible && <Typography color="error">Venmo isn't available on this browser or device.</Typography>}
			<div id="venmo-button-container" style={{ display: eligible ? 'block' : 'none' }} />
		</>
	);
}
